import type { CreditCode, Plan } from '@/shared/api';

export const CREDIT_CODE_MAP: Record<string, CreditCode> = {
  COMMERCE_PDP_GENERATION: 'COMMERCE_PDP_GENERATION', // 상세페이지 생성
  COMMERCE_ASSET_GENERATION: 'COMMERCE_ASSET_GENERATION', // 이미지 자동 생성
  COMMERCE_PDP_ADDITION: 'COMMERCE_PDP_ADDITION', // 새 시안 만들기
  COMMERCE_IMAGE_EDITING: 'COMMERCE_IMAGE_EDITING', // AI Chat - 이미지 편집
  COMMERCE_TEXT_EDITING: 'COMMERCE_TEXT_EDITING', // AI Chat - 텍스트 편집
  COMMERCE_AS_GENERATION: 'COMMERCE_AS_GENERATION', // AI Studio - 이미지 생성 (장당)
  COMMERCE_AS_INPAINTING: 'COMMERCE_AS_INPAINTING', // AI Studio - 인페인팅 (장당)
  COMMERCE_BANNER_BACKGROUND: 'COMMERCE_BANNER_BACKGROUND', // 배너 배경 생성
  COMMERCE_BANNER_GENERATION: 'COMMERCE_BANNER_GENERATION', // 배너 생성
  COMMERCE_BANNER_RESIZING: 'COMMERCE_BANNER_RESIZING', // 배너 리사이징
  COMMERCE_VIDEO_GIF: 'COMMERCE_VIDEO_GIF', // 영상 생성 (GIF)
  COMMERCE_VIDEO_SHORTFORM: 'COMMERCE_VIDEO_SHORTFORM', // 영상 생성 (CUT)
} as const;

export const PLAN_ENUM: Record<string, Plan> = {
  FREE: 'Free',
  STANDARD: 'Standard',
  PRO: 'Pro',
  PRO_PLUS: 'Pro plus',
} as const;
